/**
 * ヒーローコピーのテキストアニメーション
 * ローディングと同種のスロット演出をヒーローのキャッチコピーへ適用
 */

class HeroCopyAnimator {
  constructor() {
    this.copyWrapper = document.querySelector('.hero__copy');
    if (!this.copyWrapper) {
      return;
    }

    this.textElements = Array.from(
      this.copyWrapper.querySelectorAll('.hero__copy-en, .hero__copy-ja')
    );
    if (!this.textElements.length) {
      return;
    }

    this.letters = [];
    this.hasPlayed = false;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.prepare();
    this.bindEvents();
  }

  prepare() {
    this.copyWrapper.classList.add('hero__copy--prepared');
    if (typeof gsap !== 'undefined') {
      gsap.set(this.copyWrapper, { opacity: 0, y: 8 });
    } else {
      this.copyWrapper.style.opacity = '0';
    }
    this.textElements.forEach(el => this.splitText(el));
    if (typeof gsap !== 'undefined') {
      gsap.set(this.letters, { opacity: 0, y: 30, rotationX: 75, transformOrigin: 'center bottom' });
    }
  }

  splitText(el) {
    const original = el.textContent;
    const wrapper = document.createElement('span');
    wrapper.className = 'hero__copy-letters';
    wrapper.setAttribute('aria-hidden', 'true');

    el.setAttribute('aria-label', original);
    el.innerHTML = '';
    el.appendChild(wrapper);

    [...original].forEach(char => {
      const span = document.createElement('span');
      span.className = 'hero__copy-letter';

      if (char === ' ') {
        span.classList.add('hero__copy-letter--space');
        span.textContent = '\u00A0';
      } else if (char === '\n') {
        span.classList.add('hero__copy-letter--break');
        span.appendChild(document.createElement('br'));
      } else {
        span.textContent = char;
      }

      wrapper.appendChild(span);
      this.letters.push(span);
    });
  }

  bindEvents() {
    this.handleStart = () => this.play();
    window.addEventListener('hero:start', this.handleStart, { once: true });
    window.addEventListener('app:main-shown', this.handleStart, { once: true });
  }

  play() {
    if (this.hasPlayed) {
      return;
    }
    this.hasPlayed = true;

    if (this.reduceMotion || typeof gsap === 'undefined') {
      this.copyWrapper.style.opacity = '1';
      this.copyWrapper.style.transform = 'none';
      this.letters.forEach(letter => {
        letter.style.opacity = '1';
        letter.style.transform = 'none';
      });
      return;
    }

    const tl = gsap.timeline({ defaults: { ease: 'sine.out' } });
    tl.to(this.copyWrapper, { opacity: 1, y: 0, duration: 0.45, ease: 'power2.out' }, 0);
    tl.to(this.letters, {
      opacity: 1,
      y: 0,
      rotationX: 0,
      duration: 0.55,
      stagger: { each: 0.025, from: 'start' },
      ease: 'sine.out'
    }, 0.05);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new HeroCopyAnimator();
});

export default HeroCopyAnimator;

